export const calculateCost = (attendants: { ral: number }[], duration: number) => {
  const totalRal = attendants.reduce((acc, attendant) => acc + attendant.ral, 0);
  const hourlyCost = totalRal / (52 * 40); // Assuming 52 weeks and 40 hours per week
  return Math.round(hourlyCost * (duration / 3600)); // duration in seconds
};
